import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import video from 'assets/videos/data.mp4';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent
} from 'components/sections/hero/hero.styles';
import {
  FormContent,
  Form,
  FormTitle,
  FormLabel,
  FormInput,
  FormButton,
  FormText
} from './signin.styles';
import { Spinner } from 'components/common/Spinner';

let timeout;

const SignIn = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formFields, setFormFields] = useState({
    email: '',
    password: ''
  });

  const handleInputChange = (e) => {
    e.persist();
    setFormFields((values) => ({
      ...values,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    timeout = setTimeout(() => {
      setLoading(false);
      history.push('/');
    }, 3000);
  };

  useEffect(() => {
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  return (
    <HeroContainer id="/">
      <HeroBg>
        <VideoBg autoPlay loop muted src={video} type="video/mp4" />
        <HeroContent>
          <FormContent>
            <Form onSubmit={handleSubmit}>
              <FormTitle>Easy Sign in to your account</FormTitle>
              <FormLabel htmlFor="email">Email</FormLabel>
              <FormInput
                value={formFields.email}
                onChange={handleInputChange}
                type="email"
                name="email"
                placeholder="email"
                required
              />
              <FormLabel htmlFor="password">Password</FormLabel>
              <FormInput
                value={formFields.password}
                onChange={handleInputChange}
                type="password"
                name="password"
                placeholder="password"
                required
              />
              {loading ? (
                <Spinner />
              ) : (
                <FormButton type="submit" disabled={loading}>
                  Continue
                </FormButton>
              )}
              <FormText>Forgot password?</FormText>
            </Form>
          </FormContent>
        </HeroContent>
      </HeroBg>
    </HeroContainer>
  );
};

export default SignIn;
